export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/HEB/theme/components/scorecard/ScorecardView/ScorecardExport.js